// extracted by mini-css-extract-plugin
export default {"wrap":"SecondaryButton_wrap__B9TlU","sm":"SecondaryButton_sm__whz41","buttonText":"SecondaryButton_buttonText__FbMPY"};